document.addEventListener('DOMContentLoaded', function() {
    $('input[name="parcelas"]').change(function(event) {
        var parcel = $(this).val();
        $('#SeuNumeroNF').val($('#num-nota').val()+'-'+parcel);
        $('input[name="parcelas"]:checked').trigger('change');
    });

    $('.form-boleto').submit(function(event) {        
        $('input[name="parcelas"]').remove();
        window.open('','BOLETOS','toolbar=yes,menubar=yes,resizable=yes,status=yescom,scrollbars=yes,width=600,height=430');
        window.location.reload()
        return true;
    });
    $('input[name="nota_fiscal"]').change(function(event) {
        var inp = $(this);

        if (inp.val()) {
            var val = inp.val();
            if (val.length < 7) {
                while (val.length < 7) {
                    val = '0' + val;
                }
                inp.val(val);
            }
        }
    });
});
$(document).ready(() => {
    $(".popupBoletos").fadeIn()
});